import { Avatar, type ListRef, Typography } from '@banhala/ui-kit';
import type { FilterType } from '../../../../../../api/screensService/getScreensFilterOptions/enums';
import { useClickMore } from './useClickMore';
import { View } from 'react-native';
import { type SetFilterListBottomSheetViaQueryValueProps } from '../../Provider/filterListBottomSheet/useFilterListBottomSheetAtom';
import { useFilterHeader } from '../useFilterHeader';
import { RectangleFilterItemBox } from '../RectangleFilterItemBox/RectangleFilterItemBox';
import { RectangleFilterItem } from '../RectangleFilterItem/RectangleFilterItem';
import type { SetListHeight } from '../../hooks/useListHeight';
import { RenderItemWrapper } from '../RenderItemWrapper';
import type { Dispatch, RefObject, SetStateAction } from 'react';
import type { FormattedChildGroup } from '../../../../../../api/screensService/getScreensFilterOptions/types';

type IMultiChildGroup = {
  title: string;
  type: FilterType.MultiImage | FilterType.MultiFlow;
  entity: {
    queryName: string;
    previewItemCount: number;
    possibleItems: {
      text: string;
      queryValue: string;
      countText: string;
      isSelected: boolean;
      image?: string;
    }[];
  };
  handleClickFilter: (
    props: SetFilterListBottomSheetViaQueryValueProps & { title: string },
  ) => void;
  setListHeight: SetListHeight;
  index: number;
  setSelectedTitle: Dispatch<SetStateAction<string | null>>;
  listRef: RefObject<ListRef<FormattedChildGroup> | null>;
};

type MultiImageProps = IMultiChildGroup;

export const MultiImageFilter = ({
  index,
  entity: { possibleItems, previewItemCount, queryName },
  title,
  handleClickFilter,
  setListHeight,
}: MultiImageProps) => {
  const { isClickedMore, MoreButton } = useClickMore();
  const { Header } = useFilterHeader({ title });
  const selectedValues = possibleItems
    .filter(({ isSelected }) => isSelected)
    .map(({ queryValue }) => queryValue);

  return (
    <RenderItemWrapper
      setListHeight={setListHeight}
      index={index}
      title={title}
    >
      <Header />
      <RectangleFilterItemBox>
        {possibleItems.map(
          ({ queryValue, text, isSelected, ...rest }, index) => {
            const newValues = isSelected
              ? selectedValues.filter(
                  selectedValue => !selectedValue.includes(queryValue),
                )
              : selectedValues.concat([queryValue]);
            if (!isClickedMore && index + 1 > previewItemCount) {
              return null;
            }
            return (
              <RectangleFilterItem
                key={`${title}-${queryValue}`}
                isSelected={isSelected}
                onPress={() => {
                  handleClickFilter({
                    queryName,
                    queryValue: newValues,
                    title,
                  });
                }}
              >
                <View
                  style={{
                    borderWidth: 1,
                    borderColor: 'rgba(0, 0, 0, 0.12)',
                    width: 24,
                    height: 24,
                    borderRadius: 9999,
                    overflow: 'hidden',
                    marginRight: 12,
                  }}
                >
                  {rest.image && rest.image.length > 0 && (
                    <Avatar uri={rest.image} size={24} />
                  )}
                </View>
                <Typography type="subtitle3" color="content_primary">
                  {text}
                </Typography>
                <Typography
                  type="subtitle3"
                  color="content_tertiary"
                  marginLeft={2}
                >
                  {rest.countText}
                </Typography>
              </RectangleFilterItem>
            );
          },
        )}
      </RectangleFilterItemBox>
      {possibleItems.length > previewItemCount && MoreButton}
    </RenderItemWrapper>
  );
};
